export class Credenciales {
    email: string;
    clave: string;
}

export class ClienteForm {
    email: string;
    clave: string;
    razonSocial: string;
    cif: string;
    telefono1: string;
    telefono2: string;
    nombreComercial: string;
    direccionFacturacion: string;
    web: string;
    codigoPromocional: string;
    termsAndConditions: boolean;
    numeroTarjeta: string;
    mesTarjeta: number;
    anyoTarjeta: number;
    cvvTarjeta: number;
    tipoCliente: string;
    contactoNombre: string;
    contactoEmail: string;
}